import { CropItem } from 'plugin-pdf-plot-area/webapp/api/utils/types'

export function getSpan({
    widget,
    spanDepth,
    span,
    cropItem
}: {
    widget: Widget
    spanDepth: string
    span: string
    cropItem: CropItem
}): {
    span: string
    isDepth: boolean
    hasTicks: boolean
} {
    const isDepth = widgetIsDepth(widget)
    const hasTicks = (isDepth ? cropItem.ticksDepth : cropItem.ticksTime) > 0

    if (!hasTicks) {
        return { span: spanDisabledRealtime('none'), isDepth, hasTicks }
    }

    if (isDepth) return { span: spanDisabledRealtime(spanDepth), isDepth, hasTicks }

    return { span: spanDisabledRealtime(span), isDepth, hasTicks }
}

export function getWidgetSpan({
    widget,
    spanSelected,
    secundarySpan,
    spanSelectedIsDepth = true
}: {
    widget: Widget
    spanSelected: string
    secundarySpan?: string
    spanSelectedIsDepth?: boolean
}): string {
    if (widgetIsDepth(widget) !== spanSelectedIsDepth) {
        return spanDisabledRealtime(String(widget?.jsonConfig?.span || secundarySpan || 'none'))
    }
    return spanDisabledRealtime(spanSelected)
}

export function spanDisabledRealtime(finalSpan: string): string {
    return `(${finalSpan}) #disableRealTime`
}

export function widgetIsDepth(widget: Widget): boolean {
    if (!widget || !widget?.jsonConfig?.spanPicker) return false
    return String(widget.jsonConfig.spanPicker?.type).toLocaleLowerCase() === 'depth'
}
